<template>
  <div class="remarksStyle">
    <v-row no-gutters v-if="title" class="pb-3">
      <v-col cols="12">
        <span class="font-weight-bold titleStyle">{{ $t(title) }}</span>
        <span class="ml-3">{{ $t(text) }}</span>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12">
        <v-textarea
          outlined
          v-model="inputedValue"
          :placeholder="$t('common.input_input-note-phrase')"
          hide-details
          class="textareaStyle"
        ></v-textarea>
      </v-col>
    </v-row>
    <v-row class="pt-4" no-gutters>
      <v-col cols="12" class="yCenter">
        <div class="selectStyle pr-3">
          <v-select
            class="original-selectbox"
            v-model="selectedItem"
            :items="items"
            :placeholder="
              $t('sale.sale_select-the-fixed-phrase-you-want-to-add')
            "
            dense
            item-text="name"
            item-value="id"
            height="32px"
            outlined
            hide-details
            return-object
            :no-data-text="$t('common.common_not-note-phrase')"
          ></v-select>
        </div>
        <v-spacer> </v-spacer>
        <NormalButton
          :text="$t('common.input_add-to-note-phrase')"
          height="32px"
          width="100px"
          color="white"
          textColor="thinText--text"
          :outlined="true"
          @click="setRemarksFormat"
        />
        <v-spacer> </v-spacer>
        <NormalButton
          v-if="isRegister"
          class="ml-2"
          :text="$t('common.input_save-remarks')"
          height="32px"
          width="100px"
          @click="updateRemarks"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import NormalButton from '@/components/items/Buttons/NormalButton'
import { mapActions } from 'vuex'

export default {
  name: 'Remarks',
  components: {
    NormalButton
  },
  props: {
    value: { type: String, default: '' },
    title: { type: String, default: 'sale.sale_note' },
    text: { type: String, default: '' },
    isRegister: { type: Boolean, default: false }
  },
  data: () => {
    return {
      selectedItem: {},
      items: []
    }
  },
  methods: {
    ...mapActions('NotePhrase', ['getNotePhraseListFromApi']),
    setRemarksFormat() {
      this.inputedValue = this.selectedItem.name
    },
    updateRemarks() {
      this.$emit('updateRemarks', this.inputedValue)
    }
  },
  async created() {
    const notePhraseList = await this.getNotePhraseListFromApi()
    this.items = notePhraseList.data.map((ele) => {
      return { name: ele.body, id: ele.notePhraseId }
    })
  },
  computed: {
    inputedValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.remarksStyle {
  .selectStyle {
    // max-width: 210px;
    // min-width: 210px;
    width: 100%;
  }
  .titleStyle {
    font-size: 14px;
  }
}
</style>
